export default [
  {
    path: '/apps/tipo-endereco/list',
    name: 'apps-tipo-endereco-list',
    component: () => import('@/views/cadastros/gerais//tipoendereco/list//Index.vue'),
    meta: {
      pageTitle: 'Tipo Endereço',
      resource: 'AdminHanes',
    },
  },
];
